import { render } from "./Alert.vue?vue&type=template&id=38307014&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=38307014&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38307014"]])

export default __exports__